import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiArrowDown, FiDownload, FiMail } from "react-icons/fi";
import { personalInfo } from "../data/personalInfo";
import "./Hero.css";

const typingTexts = [
  "Full-Stack Developer",
  "WordPress Expert",
  "Laravel Specialist",
  "Performance Optimizer",
  "AI Integration Engineer",
];

const Hero = () => {
  const [textIndex, setTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    const current = typingTexts[textIndex];
    let timeout;

    if (!isDeleting && charIndex < current.length) {
      timeout = setTimeout(() => {
        setDisplayText(current.slice(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, 80);
    } else if (!isDeleting && charIndex === current.length) {
      timeout = setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && charIndex > 0) {
      timeout = setTimeout(() => {
        setDisplayText(current.slice(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, 40);
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setTextIndex((prev) => (prev + 1) % typingTexts.length);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, textIndex]);

  return (
    <section id="hero" className="hero">
      <div className="hero__bg-grid" />
      <div className="hero__container">
        <motion.div
          className="hero__content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <motion.span
            className="hero__greeting"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
          >
            Hello, I'm
          </motion.span>

          <h1 className="hero__name">{personalInfo.name}</h1>

          <div className="hero__typing-wrapper">
            <span className="hero__typing-text">{displayText}</span>
            <span className="hero__cursor">|</span>
          </div>

          <p className="hero__tagline">{personalInfo.tagline}</p>
          <p className="hero__intro">{personalInfo.shortIntro}</p>

          <div className="hero__cta-group">
            <a href="#projects" className="btn btn--primary">
              View Projects
            </a>
            <a
              href={personalInfo.resumeLink}
              className="btn btn--outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FiDownload /> Download Resume
            </a>
            <a href="#contact" className="btn btn--ghost">
              <FiMail /> Contact Me
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero__scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
        >
          <a href="#about" aria-label="Scroll down">
            <FiArrowDown className="hero__scroll-icon" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
